'use client'

import { AdLeaderboard, AdMidBanner } from '@/components/common/Ad'
import { Splash } from '@/components/common/Splash'
import { useAds } from '@/components/providers/AdsProvider'
import { CARDART } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import styles from './HomeTop.module.scss'
import { HomeTopArticles } from './HomeTopArticles/HomeTopArticles'
import { HomeTopCallout } from './HomeTopCallout/HomeTopCallout'
import { HomeTopSidebar } from './HomeTopSidebar/HomeTopSidebar'

export const HomeTop = () => {
  const { sidebarDisabled } = useAds()

  return (
    <section className={cn(styles.container, { sidebarDisabled, styles })}>
      <h1 className='visually-hidden'>
        EDHREC: EDH Recommendations and strategy content for Magic: the Gathering Commander.
      </h1>
      <div className={styles.content}>
        <Splash
          align='outsideLeft'
          aspectRatio='1/2'
          backgroundImages={[CARDART.KAALIA]}
          breakpoint='xxl'
          isAboveFold
          objectPosition='65% center'
        />
        <Splash
          align='outsideRight'
          aspectRatio='1/2'
          backgroundImages={[CARDART.THE_UR_DRAGON]}
          breakpoint='xxl'
          flipX
          isAboveFold
          objectPosition='25% center'
        />
        <div className={styles.adLeaderboard}>
          <AdLeaderboard margin='none' />
        </div>
        <div className={styles.callout}>
          <HomeTopCallout />
        </div>
        <div className={styles.articles}>
          <HomeTopArticles />
        </div>
        <div className={styles.sidebar}>
          <HomeTopSidebar />
        </div>
        <div className={styles.adMidBanner}>
          <AdMidBanner padding='none' />
        </div>
      </div>
    </section>
  )
}
